import {setBearerTokenCookie} from "./cookies";

/**
 * Extracts bearer token from URL parameter 't', saves it to cookie,
 * and removes it from the URL. Must be called synchronously before React renders.
 */
export const processTokenFromUrl = () => {
    try {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get("t");

        if (!token?.trim()) return;

        setBearerTokenCookie(token);

        urlParams.delete("t");
        // Preserve hash — Cookiebot uses #cc=... for consent state.
        const newUrl = urlParams.toString()
            ? `${window.location.pathname}?${urlParams.toString()}${window.location.hash}`
            : `${window.location.pathname}${window.location.hash}`;

        window.history.replaceState(window.history.state, "", newUrl);
    } catch (error) {
        console.error("Error processing bearer token from URL:", error);
    }
};
